import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Invoice } from "../../order/model/invoice.model";
import { SettlementReferenceModel } from "./settlementreference.model";
import { SettlementInvoiceModel } from "./settlementinvoice.model";
import { ReceiptPaymentModel } from "../../order/model/receiptpayment.model";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { CostSpent } from "../../cost/model/costspent.model";
import { DriverSettlementFormSettingModel } from "../driversettlement/driversettlementformsetting.model";
import { CostSpentFormSettingModel } from "../../cost/spentcost/costspentformsetting.model";

export class UserSettlementModel extends EntityBase {
  SettledPersonnelId: number;
  SettledUserlId: number;
  Code: number;
  TotalDiscount: number;
  ClearedInvoicesTotal: number;
  TotalTax: number;
  PayableTotal: number;
  CustomerNumber: string;
  InvoiceDebit: number;
  InvoiceCredit: number;
  Description: string;
  InvoicesDiscount: number;
  AllowedDeficit: number;
  ShippingCostReducePrice: number;
  UntilDate?: Date;
  UntilTime: string;
  OldRemain: number;
  Remain: number;
  NewRemainValue: number;
  Amount: number;
  TotalPayment: number;
  TotalDeposit: number;
  TotalReciptPayment: number;
  PaymentMethodTypeId: number;
  PaymentMethodTypeIndex: number;
  PaymentMethodTitle: string;
  Invoice: Invoice[];
  ReceiptPayments: ReceiptPaymentModel[];
  ReceiptPaymentTypeTitle: string;
  SettlementReferences: SettlementReferenceModel[];
  Invoices: SettlementInvoiceModel[];
  public AccVoucherFixNumber?: number;
  public AccVoucherNo?: number;
  public FiscalYearId: number;
  public CustomerClearedTotal: number;
  PaymentLink: number;
  DebitInvoiceIds: number[];
  PaymentLinkIds: number[];
  OnlinePaymentIds: number[];
  CreditInvoiceIds: number[];
  DepositReceiptPaymentIds: number[];
  DiscountInvoiceIds: number[];
  CostSpentIds: number[];
  SettlementTypeId: number;
  SettlementType: Lookup[];
  PayableTotalPrice: number;
  DriverShippingCostReducedIds: number[];

  constructor() {
    super();
    this.TotalReciptPayment = 0;
    this.TotalPayment = 0;
    this.PayableTotal = 0;
    this.AllowedDeficit = 0;
    this.ReceiptPayments = [];
    this.SettlementReferences = [];
  }
}
export class DriverSettlementModel extends UserSettlementModel {
  CourierShippingCost: number;
  ShippingCost: number;
  ShippingAddress: string;
  PayableWithCourierShippingCost: number;
  PayableWithShippingCost: number;
  TerminalNumber: string;
  OnlinePayment: number;
  DriverFirstNameTitle: string;
  DriverLastNameTitle: string;
  InvoiceIds: number[];
  AccFixNo: number;
  DriverSettlementFormSettingModel: DriverSettlementFormSettingModel;
  CostSpentFormSettingViewModel: CostSpentFormSettingModel = new CostSpentFormSettingModel();
  constructor() {
    super();
  }
}
export class CashierSettlementModel extends UserSettlementModel {
  PendingInvoicesTotal: number;
  CancelledInvoicesTotal: number;
  DeletedInvoicesTotal: number;
  PassiveInvoicesTotal: number;
  CustomerClearedInvoicesTotal: number;
  PersonnelClearedInvoicesTotal: number;
  PersonnelReceiptPaymentPaid: number = 0;
  TipTotal: number;
  DebitTotal: number;
  CreditTotal: number;
  InvoicesTotal: number;
  AddSettlementForPending: boolean;
  CashierFirstNameTitle: string;
  CashierLastNameTitle: string;
  PersonnelClearedInvoices: CashierSettlementModel[];
  PersonnelReceiptPayments: ReceiptPaymentModel[];
  ClearedInvoiceIds: number[];
  CancelledInvoiceIds: number[];
  DeletedInvoiceIds: number[];
  CustomerClearedIds: number[];
  PassiveInvoiceIds: number[];
  PendingInvoiceIds: number[];
  PersonnelClearedIds: number[];
  public AccVoucherFixNumber?: number;
  public AccVoucherNo?: number;
  public FiscalYearId: number;
  Description: string;
  ReceiptPayments: ReceiptPaymentModel[];
  SettlementReferences: SettlementReferenceModel[];
  TotalAccount: number;
  CashierSpentCost: number;
  CostSpents: CostSpent;
  AccVoucherId: number;
  AccFixNo: number;
  constructor() {
    super();
    this.SettlementReferences = [];
  }
}
export class CustomerSettlementModel extends UserSettlementModel {
  CustomerTitle: string;
  DebitTotal?: number;
}
export enum SettlementType {
  DriverSettlement = 1,
  CashierSettlement = 2,
  CustomerSettlement = 3,
}
export class SettlementDateViewModel {
  UntilDate?: Date;
  UntilTime: string;
}

export interface DriverLookup extends Lookup {
  Id: number;
  Title: string;
  PersonnelId: number;
  TerminalNumber: string;
}
